/* src/app/components/thumbnail-pdf/thumbnail-pdf.component.scss */
.container {
  position: relative;
}
.page-container {
  position: relative;
}
.container-i {
  position: absolute;
  background-color: white;
}
.container-i .img1 {
  position: absolute;
}
.gap-2 {
  gap: 0.5rem !important;
}
.flex-row {
  flex-direction: row !important;
}
.flex {
  display: flex !important;
}
.border-1 {
  border-width: 1px !important;
  border-style: solid;
}
/*# sourceMappingURL=thumbnail-pdf.component-H2ZIEETR.css.map */
